import statementReportRedux from '../../list/redux/reducer';

//export redux objects
export default {
	statementReportRedux
};
